<template>
  <div class="pcn-card" :class="cardClass" :id="id" :style="cardStyle" @click="onCardClick" ref="card">
    <div class="media" :style="mediaStyle" v-if="imageUrl || videoUrl || mediaCard">
      <img v-if="imageUrl" :src="require(`@/assets/images/${imageUrl}`)" :alt="imageDescription">
      <img v-else-if="title == 'The Phoenix Practice'" src="https://patientlink-uploads.s3.eu-west-2.amazonaws.com/member_practices/pheonix-practice.png" :alt="imageDescription">
      <img v-else-if="title == 'Dr Azim and Partners'" src="https://patientlink-uploads.s3.eu-west-2.amazonaws.com/member_practices/dr-azim.png" :alt="imageDescription">
      <img v-else-if="title == 'Pennine Drive Practice'" src="https://patientlink-uploads.s3.eu-west-2.amazonaws.com/member_practices/pennine-drive.png" :alt="imageDescription">
      <img v-else-if="title == 'The Hillview Surgery'" src="https://patientlink-uploads.s3.eu-west-2.amazonaws.com/member_practices/hill-view.png" :alt="imageDescription">
      <img v-else-if="title == 'St Georges Medical Centre'" src="https://patientlink-uploads.s3.eu-west-2.amazonaws.com/member_practices/st-georges.png" :alt="imageDescription">
      <img v-else-if="title == 'Ravenscroft Medical Centre'" src="https://patientlink-uploads.s3.eu-west-2.amazonaws.com/member_practices/ravenscroft.png" :alt="imageDescription">
      <img v-else-if="title == 'Greenfield Medical Centre'" src="https://patientlink-uploads.s3.eu-west-2.amazonaws.com/member_practices/green-fields.png" :alt="imageDescription">
      <img v-else-if="title == 'Cricklewood Health Centre'" src="https://patientlink-uploads.s3.eu-west-2.amazonaws.com/member_practices/cricklewood.png" :alt="imageDescription">
      <template v-else-if="videoUrl">
        <youtube v-if="youtubeId" :video-id="youtubeId" :width="mediaWidth" :height="mediaHeight" ref="youtube" @playing="playing" @paused="onPause" @ended="onPause" @ready="onReady"></youtube>
        <button class="play" @click="onPlay" v-if="!videoPlaying">
          <img :src="require('@/assets/images/play-btn.svg')" alt="play button">
        </button>
      </template>
      <div class="no-image" v-if="media">
        <img :src="require('@/assets/images/no-image.svg')" alt="no image" style="padding:30%">
      </div>
    </div>
    <div class="pcn-card-content" :style="contentStyle">
      <h4 class="title" v-if="title" v-html="title" :style="type === 'memberPractice' ? {fontSize: '14px', lineHeight: '21px'} : type === 'staffMembers' ? {fontSize: '14px', lineHeight: '21px', margin: 'auto'} : {}"></h4>
      <div class="text" v-if="text" v-html="text" :style="type === 'news' ? {maxHeight: '84px'} : {}"></div>
      <div class="card-footer" v-if="type !== 'staffMembers'">
        <div class="date" :class="{'color-blue': type === 'event'}" v-if="date">{{transformDate(date)}}</div>
        <el-button type="text" v-if="type==='minutes'" class="download" @click="$emit('download-click')"><i class="el-icon-download"></i></el-button>
        <div class="date" style="margin-left: auto" v-if="videoDuration">{{videoDuration}}</div>
        <div class="date" :class="{'color-blue': type === 'event'}" style="margin-left: auto" v-if="scheduledTimings">{{scheduledTimings}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { videoMixin } from '@/mixins/videoMixin'
  export default {
    name: "pcn-card",
    props: {
      id: {
        type: String
      },
      type: {
        type: String
      },
      media: {
        type: Boolean
      },
      borderColor: {
        type: String
      },
      cardClass: {
        type: String
      },
      title: {
        type: String
      },
      text: {
        type: String
      },
      date: {
        type: String
      },
      timeFrom: {
        type: String
      },
      timeTo: {
        type: String
      },
      imageUrl: {
        type: String
      },
      imageDescription: {
        type: String
      },
      videoUrl: {
        type: String
      },
      link: {
        type: String
      }
    },
    mixins: [videoMixin],
    data() {
      return {
        mediaCardTypes: ['video', 'memberPractice'],
        mediaStyle: {},
        contentStyle: {},
        mediaWidth: 0,
        mediaHeight: 0,
        cardEl: null
      }
    },
    computed: {
      mediaCard() {
        return this.mediaCardTypes.includes(this.type)
      },
      cardStyle() {
        const style = {
          borderTopColor: 'transparent',
          border: 'none',
          height: 'auto',
          cursor: 'default'
        }
        switch (this.type) {
          case 'memberPractice':
            style.cursor = 'pointer'
            break
          case 'event':
            delete style.border
            style.height = '300px'
            style.borderTopColor = '#f35022'
            break
          case 'staff':
            delete style.border
            style.height = '300px'
            style.borderTopColor = '#715bff'
            break
          case 'minutes':
            delete style.border
            style.height = '138px'
            style.borderTopColor = '#C0007C'
            style.cursor = 'pointer'
            break
          case 'news':
            delete style.border
            style.height = '350px'
            style.borderTopColor = '#715BFF'
            break
          case 'video':
            delete style.border
            style.height = '350px'
            style.borderTopColor = '#07a7f0'
            break
          case 'staffMembers':
            delete style.border
            style.height = '137px'
            style.textAlign = 'center'
            style.cursor = 'pointer'
            style.borderTopColor = '#715bff'
            break
          default:
            style.height = 'auto'
        }
        if (this.borderColor) {
          delete style.border
          style.borderTopColor = this.borderColor
        }
        return style
      },
      scheduledTimings() {
        if (this.timeFrom && this.timeTo) {
          return `${this.timeFrom} - ${this.timeTo}`
        }
        if (this.timeFrom) {
          return `${this.timeFrom}`
        }
        return ''
      }
    },
    methods: {
      getStyles() {
        const card = this.$refs.card
        const width = card.getBoundingClientRect().width
        const height = (+width * 0.65).toFixed(0)
        this.mediaStyle = { height: `${height}px`} 
        this.contentStyle = { height: `calc(100% - ${height}px)`}
        this.mediaWidth = width 
        this.mediaHeight = height 
      },
      transformDate(date) {
        return this.$date(new Date(date), 'd MMM yyyy');
      },
      onCardClick() {
        console.log('click')
        if (this.type==='minutes') {
          this.$emit('download-click')
          return
        }
        this.$emit('card-click')
      }
    },
    mounted() {
      if (!this.mediaCard) return
      this.cardEl = this.$refs.card
      this.getStyles()
    },
    watch: {
      type() {
        this.mediaStyle = {}
        this.contentStyle = {}
        if (!this.mediaCard) return
        this.getStyles()
      }
    }
  }
</script>
